/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActuatorService } from './services/actuator.service';
import { ClientService } from './services/client.service';
import { VatService } from './services/vat.service';
import { CurrencyService } from './services/currency.service';
import { BankService } from './services/bank.service';
import { AircraftService } from './services/aircraft.service';
import { CostCenterService } from './services/cost-center.service';
import { InvoiceService } from './services/invoice.service';
import { QuotationService } from './services/quotation.service';
import { ContractService } from './services/contract.service';
import { CountryService } from './services/country.service';
import { ServiceItemService } from './services/service-item.service';
import { WorkOrderService } from './services/work-order.service';
import { UnitService } from './services/unit.service';
import { AcmsAircraftService } from './services/acms-aircraft.service';
import { AcmsAircraftServiceItemService } from './services/acms-aircraft-service-item.service';
import { WorkOrderFileService } from './services/work-order-file.service';
import { ServiceOrderService } from './services/service-order.service';
import { ServiceOrderItemService } from './services/service-order-item.service';
import { LineItemTypeService } from './services/line-item-type.service';
import { AdvancePaymentsService } from './services/advance-payments.service';
import { PaymentsService } from './services/payments.service';
import { ZatcaService } from './services/zatca.service';
import { ReportService } from './services/report.service';
import { TripReportService } from './services/trip-report.service';
import { CreditNoteService } from './services/credit-note.service';
import { FileRequestService } from './services/file-request.service';
import { WorkOrderLogService } from './services/work-order-log.service';
import { SalesWorkOrdersService } from './services/sales-work-orders.service';
import { SalesOrdersService } from './services/sales-orders.service';
import { AirportManagementUnitService } from './services/airport-management-unit.service';
import { DivisionService } from './services/division.service';
import { AccountService } from './services/account.service';
import { CmReasonService } from './services/cm-reason.service';
import { InvoiceLineItemService } from './services/invoice-line-item.service';
import { BusinessTypeEbsConfigService } from './services/business-type-ebs-config.service';
import { BusinessTypeEbsIntegrationService } from './services/business-type-ebs-integration.service';
import { MealCategoryService } from './services/meal-category.service';
import { InternetPackageService } from './services/internet-package.service';
import { LayoverCategoryService } from './services/layover-category.service';
import { WaitingCategoryService } from './services/waiting-category.service';
import { CharterContractService } from './services/charter-contract.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActuatorService,
    ClientService,
    VatService,
    CurrencyService,
    BankService,
    AircraftService,
    CostCenterService,
    InvoiceService,
    QuotationService,
    ContractService,
    CountryService,
    ServiceItemService,
    WorkOrderService,
    UnitService,
    AcmsAircraftService,
    AcmsAircraftServiceItemService,
    WorkOrderFileService,
    ServiceOrderService,
    ServiceOrderItemService,
    LineItemTypeService,
    AdvancePaymentsService,
    PaymentsService,
    ZatcaService,
    ReportService,
    TripReportService,
    CreditNoteService,
    FileRequestService,
    WorkOrderLogService,
    SalesWorkOrdersService,
    SalesOrdersService,
    AirportManagementUnitService,
    DivisionService,
    AccountService,
    CmReasonService,
    InvoiceLineItemService,
    BusinessTypeEbsConfigService,
    BusinessTypeEbsIntegrationService,
    MealCategoryService,
    InternetPackageService,
    LayoverCategoryService,
    WaitingCategoryService,
    CharterContractService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
